"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csrfHandler = exports.setCSRFToken = exports.getCSRFToken = void 0;
const getCSRFToken = () => ocm?.config?.CSRFToken;
exports.getCSRFToken = getCSRFToken;
const setCSRFToken = (token) => {
    ocm.config.CSRFToken = token;
};
exports.setCSRFToken = setCSRFToken;
const csrfHandler = (failedRequest) => {
    const token = failedRequest?.response?.headers["csrftoken"];
    token && (0, exports.setCSRFToken)(token);
    if (failedRequest.response?.config.headers && token) {
        failedRequest.response.config.headers["CSRFToken"] = token;
    }
    return Promise.resolve();
};
exports.csrfHandler = csrfHandler;
